import { RouteObject } from "react-router";
import { AnonymousRoute } from "modules/common/components/routing/AnonymousRoute";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import React from "react";
import AccessPage from "./access/components/AccessPage";
import { AccessStoreType } from "./access/models/access-store";
import { AuthPage } from "./auth/components/AuthPage";
import { SessionType } from "./auth/models/session";
import { FormAgentPage } from "./formAgentPage/FormAgentPage";
import SettingsPage from "./settings/components/SettingsPage";
import { SettingsStoreType } from "./settings/models/settings";
import { TokensTabsPage } from "./tokens/components/TokensTabsPage";
import { TokensStoreType } from "./tokens/models/tokens-store";
import { can } from "./auth/access";
import func from "./functionalities";

export const buildRoutes = ({ tokens, session, access, settings, baseUrl }: RoutesProps): RouteObject[] => {
  const loggedIn = session.loggedIn;
  const agent = session.agent;

  return [
    {
      path: `${routes.login}/*`,
      element: (
        <AnonymousRoute loggedIn={loggedIn}>
          <AuthPage store={session} />
        </AnonymousRoute>
      ),
    },
    {
      path: `${routes.tokens.path}/*`,
      element: (
        <ProtectedRoute loggedIn={loggedIn}>
          <TokensTabsPage store={tokens} canManageUsers={can(func.SETTINGS_EDIT, session.access)} />
        </ProtectedRoute>
      ),
    },
    {
      path: `${routes.access}/*`,
      element: (
        <ProtectedRoute loggedIn={loggedIn}>
          <AccessPage store={access} session={session} />
        </ProtectedRoute>
      ),
    },
    {
      path: `${routes.settings}/*`,
      element: (
        <ProtectedRoute loggedIn={loggedIn}>
          <SettingsPage store={settings} collapser={settings.collapser} />
        </ProtectedRoute>
      ),
    },
    {
      path: `${routes.partnerForm}/*`,
      element: (
        <AnonymousRoute loggedIn={loggedIn}>
          <FormAgentPage baseUrl={baseUrl} session={session} agent={agent} />
        </AnonymousRoute>
      ),
    },
  ];
};

interface RoutesProps {
  tokens: TokensStoreType;
  session: SessionType;
  access: AccessStoreType;
  settings: SettingsStoreType;
  baseUrl: string;
}
